import { useState } from 'react'
import { IconClapper, IconCalendar, IconTicket } from './icons'

export function SaveExitModal({ onSaveExit, onStay, body }) {
  return (
    <div className="save-modal-overlay" onClick={onStay}>
      <div className="save-modal" onClick={(e) => e.stopPropagation()}>
        <p className="save-modal__title">Hold on! <IconClapper size={16} style={{ verticalAlign: 'middle' }} /></p>
        <p className="save-modal__body">
          {body || "You have an active game in progress. Want to save it and come back later?"}
        </p>
        <div className="save-modal__actions">
          <button className="btn-primary" onClick={onSaveExit}>Save &amp; Exit</button>
          <button className="btn-ghost" onClick={onStay}>Stay on Set</button>
        </div>
      </div>
    </div>
  )
}

export function DailyLeaveModal({ onLeave, onStay }) {
  return (
    <div className="save-modal-overlay" onClick={onStay}>
      <div className="save-modal" onClick={(e) => e.stopPropagation()}>
        <p className="save-modal__title save-modal__title--mute">Leave today's daily? <IconCalendar size={16} style={{ verticalAlign: 'middle' }} /></p>
        <p className="save-modal__body">
          Your progress won't be saved, but your streak is safe.
        </p>
        <div className="save-modal__actions">
          <button className="btn-primary" onClick={onLeave}>Leave</button>
          <button className="btn-ghost" onClick={onStay}>Stay on Set</button>
        </div>
      </div>
    </div>
  )
}

export function AbandonConfirmModal({ ticketsCost, onAbandon, onKeep }) {
  return (
    <div className="save-modal-overlay" onClick={onKeep}>
      <div className="save-modal" onClick={(e) => e.stopPropagation()}>
        <p className="save-modal__title">Are you sure?</p>
        <p className="save-modal__body">
          This game cost you <strong>{ticketsCost} <IconTicket size={13} style={{ verticalAlign: 'middle' }} /></strong> and cannot be refunded.
        </p>
        <div className="save-modal__actions">
          <button className="btn-primary" onClick={onAbandon}>Abandon Game</button>
          <button className="btn-ghost" onClick={onKeep}>Keep It</button>
        </div>
      </div>
    </div>
  )
}

export function ResumeOrNewModal({ savedGame, ticketCost, onResume, onStartNew, onMaybeLater }) {
  const [confirming, setConfirming] = useState(false)
  const isSetup = savedGame?.stage === 'actor_selection'

  if (confirming) {
    return (
      <div className="save-modal-overlay" onClick={() => setConfirming(false)}>
        <div className="save-modal" onClick={(e) => e.stopPropagation()}>
          <p className="save-modal__title">Start New Game?</p>
          <p className="save-modal__body">
            This will cost <strong>{ticketCost} <IconTicket size={13} style={{ verticalAlign: 'middle' }} /></strong> and your saved game will be lost. Are you sure?
          </p>
          <div className="save-modal__actions">
            <button className="btn-primary" onClick={onStartNew}>Confirm — {ticketCost} <IconTicket size={13} style={{ verticalAlign: 'middle' }} /></button>
            <button className="btn-ghost" onClick={() => setConfirming(false)}>← Go Back</button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="save-modal-overlay" onClick={onMaybeLater}>
      <div className="save-modal" onClick={(e) => e.stopPropagation()}>
        <p className="save-modal__title">You have a saved game <IconClapper size={16} style={{ verticalAlign: 'middle' }} /></p>
        {isSetup ? (
          <p className="save-modal__body">Actor selection in progress — your picks weren't saved yet.</p>
        ) : (
          <>
            <p className="save-modal__game-line">
              <strong>{savedGame?.startActor?.name}</strong>
              <span className="save-modal__arrow"> → </span>
              <strong>{savedGame?.goalActor?.name}</strong>
            </p>
            <p className="save-modal__meta">
              {savedGame?.moves ?? 0} {(savedGame?.moves ?? 0) === 1 ? 'hop' : 'hops'} · {formatSecs(savedGame?.elapsedSeconds || 0)}
            </p>
          </>
        )}
        <div className="save-modal__actions">
          <button className="btn-primary" onClick={onResume}>Resume Game <IconClapper size={15} style={{ verticalAlign: 'middle' }} /></button>
          <button className="btn-ghost" onClick={() => setConfirming(true)}>Start New Game</button>
          <button className="btn-ghost save-modal__btn--muted" onClick={onMaybeLater}>Maybe Later</button>
        </div>
      </div>
    </div>
  )
}

function formatSecs(s) {
  const m = Math.floor(s / 60).toString().padStart(2, '0')
  const ss = (s % 60).toString().padStart(2, '0')
  return `${m}:${ss}`
}

export function ResumeBanner({ savedGame, onResume, onAbandon }) {
  if (!savedGame) return null

  const isSetupStage = savedGame.stage === 'actor_selection'

  return (
    <div className="resume-banner">
      <p className="resume-banner__title">You have an unfinished game <IconClapper size={16} style={{ verticalAlign: 'middle' }} /></p>
      {isSetupStage ? (
        <p className="resume-banner__line resume-banner__line--setup">
          Resume game setup <IconClapper size={15} style={{ verticalAlign: 'middle' }} /> — pick your actors and start playing
        </p>
      ) : (
        <>
          <p className="resume-banner__line">
            <strong>{savedGame.startActor?.name}</strong>
            <span className="resume-banner__arrow"> → </span>
            <strong>{savedGame.goalActor?.name}</strong>
          </p>
          <p className="resume-banner__meta">
            {savedGame.moves} {savedGame.moves === 1 ? 'hop' : 'hops'} · {formatSecs(savedGame.elapsedSeconds || 0)}
          </p>
        </>
      )}
      <div className="resume-banner__actions">
        <button className="btn-primary" onClick={onResume}>Resume <IconClapper size={15} style={{ verticalAlign: 'middle' }} /></button>
        <button className="btn-ghost" onClick={onAbandon}>Abandon</button>
      </div>
    </div>
  )
}
